import { Button, Card, CardBody, Form } from "reactstrap"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import * as Yup from "yup"
import ImageCropModal from "components/ImageCropModal"
import { UPDATE_PVS_REGISTRATION_RESET } from "../../../redux/types/pvs"
import { useDispatch, useSelector } from "react-redux"
import { updatePvsRegistration } from "../../../redux/actions/pvs"
import ErrorPopup from "components/ErrorPopup"
import { toast } from "react-toastify"

const Step3 = props => {
  const dispatch = useDispatch()
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  const [imgSrc, setImgSrc] = useState("")
  const [isOpen, setIsOpen] = useState(false)
  const [currentField, setCurrentField] = useState("")

  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const updatePvsRegistrationScreen = useSelector(
    state => state.screens.pvs.updatePvsRegistration
  )

  useEffect(() => {
    if (updatePvsRegistrationScreen.success && props.activeTab === 3) {
      // toast.success(updatePvsRegistrationScreen.message)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
      props.toggleTab(props.activeTab + 1)
    }
    if (updatePvsRegistrationScreen.error && props.activeTab === 3) {
      setIsErrorMessage(updatePvsRegistrationScreen.error)
      setIsErrorOpen(true)
      // toast.error(updatePvsRegistrationScreen.error)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
    }
  }, [updatePvsRegistrationScreen])

  useEffect(() => {
    if (imgSrc) {
      setIsOpen(true)
    }
  }, [imgSrc])

  useEffect(() => {
    if (pvsFormData) {
      if (pvsFormData.seller_photo && pvsFormData.seller_photo_path) {
        convertUrlToBlob(
          "profilePhoto",
          pvsFormData.seller_photo,
          pvsFormData.seller_photo_path
        )
      }
      if (pvsFormData.brand_logo && pvsFormData.brand_logo_path) {
        convertUrlToBlob(
          "companyLogo",
          pvsFormData.brand_logo,
          pvsFormData.brand_logo_path
        )
      }
    }
  }, [pvsFormData])

  const MAX_FILE_SIZE = 8 * 1024 * 1024 // 8 MB

  async function convertUrlToBlob(fieldName, filename, url) {
    try {
      // Fetch the previously-uploaded image data from its URL
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`Failed to load document (${response.status})`)
      }

      // Get the response data as a Blob
      const blob = await response.blob()

      // Determine the file type (MIME type) from the blob
      // Fallback to a default type if the response doesn't provide one
      const type = blob.type || "image/jpeg"

      // Create a new File object using the Blob, filename, and type
      const file = new File([blob], filename, { type })

      formik.setFieldValue(fieldName, {
        file,
        name: file.name,
        type: file.type,
        url: URL.createObjectURL(file),
      })
    } catch (err) {
      // Leave the field empty rather than crashing re-hydration if the stored
      // image can't be fetched (403/CORS); the user can re-upload it.
      console.error(`Could not load existing document (${fieldName}):`, err)
    }
  }

  function onSelectFile(event, fieldType) {
    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }
    if (file.size > MAX_FILE_SIZE) {
      alert("File is too large. Please upload an image up to 8 MB.")
      return
    }

    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader()
      reader.onload = e => {
        setCurrentField(fieldType)
        setImgSrc(e.target.result)
      }
      reader.readAsDataURL(event.target.files[0])
    }
  }

  function saveImage(blob, blobUrl) {
    const file = new File([blob], `${currentField}.jpg`, {
      type: blob.type,
      lastModified: Date.now(),
    })

    formik.setFieldValue(currentField, {
      name: file.name,
      file: file,
      url: blobUrl,
    })
  }

  const formik = useFormik({
    initialValues: {
      profilePhoto: null,
      companyLogo: null,
    },
    validationSchema: Yup.object({
      profilePhoto: Yup.mixed().required("Profile Photo is required"),
      companyLogo: Yup.mixed().required("Company Logo is required"),
    }),
    onSubmit: values => {
      const formData = new FormData()
      formData.append("step", "3")
      formData.append("pvs_entry_id", pvsFormData.pvs_entry_id)
      formData.append("seller_photo", values.profilePhoto.file)
      formData.append("brand_logo", values.companyLogo.file)
      dispatch(updatePvsRegistration(formData))
    },
  })

  useEffect(() => {
    if (formik.isSubmitting && formik.errors) {
      formik.setSubmitting(false)
      if (Object.keys(formik.errors).length > 0) {
        let message = (
          <div>
            <ul className="mb-0 ps-3">
              {Object.keys(formik.errors).map(key => (
                <li key={key} className="mb-3">
                  {formik.errors[key]}
                </li>
              ))}
            </ul>
          </div>
        )
        setIsErrorMessage(message)
        setIsErrorOpen(true)
      }
    }
  }, [formik])

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Card>
        <CardBody>
          <h4 className="nom-title mb-4">Upload ID Card Details</h4>
          <p className="text-muted small mb-4">
            Note: Upload files up to 5 MB in JPG, JPEG, PNG, or PDF format.
          </p>
          <div className="row">
            <div className="col-md-12">
              <div className="mb-4 pb-2">
                <h6 className="mb-2">
                  Profile Photo <span style={{ color: "red" }}>*</span>
                </h6>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div
                      className="rounded-3 text-center d-flex flex-column align-items-center justify-content-center upload-box-style"
                      onClick={() =>
                        document.getElementById("profilePhoto").click()
                      }
                    >
                      <i className="mdi mdi-cloud-upload-outline display-6 mb-2"></i>
                      <p className="mb-0 fw-medium">
                        Click here to upload the file
                      </p>

                      <input
                        type="file"
                        id="profilePhoto"
                        className="d-none"
                        onChange={e => {
                          onSelectFile(e, "profilePhoto")
                        }}
                      />
                    </div>

                    {formik.errors.profilePhoto && (
                      <div className="text-danger small mt-1">
                        {formik.errors.profilePhoto}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="verifiedcardstyle">
                      <div className="verifiedinner-photobox">
                        {!formik.values.profilePhoto ? (
                          <i className="mdi mdi-file-image-outline display-6 text-muted"></i>
                        ) : (
                          <img
                            src={formik.values.profilePhoto.url}
                            alt="Profile inside card"
                            className="verified-innerimage img-fluid"
                          />
                        )}
                      </div>
                    </div>

                    {formik.values.profilePhoto && (
                      <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() =>
                            window.open(
                              formik.values.profilePhoto.url,
                              "_blank"
                            )
                          }
                        >
                          View
                        </button>

                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={() =>
                            formik.setFieldValue("profilePhoto", null)
                          }
                        >
                          Remove
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="mb-4 mt-4">
                <h6 className="mb-2">
                  Company Logo <span style={{ color: "red" }}>*</span>
                </h6>

                <div className="row g-3">
                  <div className="col-md-6">
                    <div
                      className="rounded-3 text-center d-flex flex-column align-items-center justify-content-center upload-box-style"
                      onClick={() =>
                        document.getElementById("companyLogo").click()
                      }
                    >
                      <i className="mdi mdi-cloud-upload-outline display-6 mb-2"></i>
                      <p className="mb-0 fw-medium">
                        Click here to upload the file
                      </p>

                      <input
                        type="file"
                        id="companyLogo"
                        className="d-none"
                        onChange={e => onSelectFile(e, "companyLogo")}
                      />
                    </div>

                    {formik.errors.companyLogo && (
                      <div className="text-danger small mt-1">
                        {formik.errors.companyLogo}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="verifiedcardstyle">
                      <div className="verifiedinner-photobox">
                        {!formik.values.companyLogo ? (
                          <i className="mdi mdi-file-image-outline display-6 text-muted"></i>
                        ) : (
                          <img
                            src={formik.values.companyLogo.url}
                            alt="Logo inside card"
                            className="verified-innerimage img-fluid"
                          />
                        )}
                      </div>
                    </div>

                    {formik.values.companyLogo && (
                      <div className="d-flex justify-content-center gap-3 mt-3">
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm"
                          onClick={() =>
                            window.open(formik.values.companyLogo.url, "_blank")
                          }
                        >
                          View
                        </button>

                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm"
                          onClick={() =>
                            formik.setFieldValue("companyLogo", null)
                          }
                        >
                          Remove
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Buttons */}
      <div className="pvs-reg-actions actions">
        <div className="btngroup-pvs">
          <div>
            <Button
              color="primary"
              size="md"
              disabled={props.activeTab === 1}
              onClick={() => props.toggleTab(props.activeTab - 1)}
            >
              <i className="dripicons-arrow-thin-left"></i>
              <span>Previous</span>
            </Button>
          </div>

          <div>
            <Button color="primary" size="md" type="submit">
              <span>Save & Continue</span>
              <i className="dripicons-arrow-thin-right"></i>
            </Button>
          </div>
        </div>
      </div>
      <ImageCropModal
        isOpen={isOpen}
        imgSrc={imgSrc}
        saveImage={saveImage}
        toggle={() => setIsOpen(false)}
      />
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
    </Form>
  )
}

export default Step3
